// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts"
// @generated from file parties.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { PartiesList, PartiesServiceCreateRequest, PartiesServiceFilterReq, PartiesServicePaginationReq, PartiesServiceSearchAllReq, PartiesServiceUpdateRequest, Party, PartyPaginationResp } from "./parties_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ActiveRequest, CountRequest, CountResponse, CSVImport, ErroredResponse, Identifier, IdentifierWithUserComment, StandardFile } from "./base_pb.js";

/**
 *
 * Describes the methods applicable on each party
 *
 * @generated from service nail2poll.PartiesService
 */
export const PartiesService = {
  typeName: "nail2poll.PartiesService",
  methods: {
    /**
     * Create a party
     *
     * @generated from rpc nail2poll.PartiesService.Create
     */
    create: {
      name: "Create",
      I: PartiesServiceCreateRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * Update a party
     *
     * @generated from rpc nail2poll.PartiesService.Update
     */
    update: {
      name: "Update",
      I: PartiesServiceUpdateRequest,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * Archive the party
     *
     * @generated from rpc nail2poll.PartiesService.Archive
     */
    archive: {
      name: "Archive",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * Restore the party
     *
     * @generated from rpc nail2poll.PartiesService.Restore
     */
    restore: {
      name: "Restore",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * View by UUID
     *
     * @generated from rpc nail2poll.PartiesService.ViewByUUID
     */
    viewByUUID: {
      name: "ViewByUUID",
      I: Identifier,
      O: Party,
      kind: MethodKind.Unary,
    },
    /**
     * View all parties
     *
     * @generated from rpc nail2poll.PartiesService.ViewAll
     */
    viewAll: {
      name: "ViewAll",
      I: ActiveRequest,
      O: PartiesList,
      kind: MethodKind.Unary,
    },
    /**
     * View parties with pagination
     *
     * @generated from rpc nail2poll.PartiesService.ViewWithPagination
     */
    viewWithPagination: {
      name: "ViewWithPagination",
      I: PartiesServicePaginationReq,
      O: PartyPaginationResp,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given search key
     *
     * @generated from rpc nail2poll.PartiesService.SearchAll
     */
    searchAll: {
      name: "SearchAll",
      I: PartiesServiceSearchAllReq,
      O: PartiesList,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given filter criteria
     *
     * @generated from rpc nail2poll.PartiesService.Filter
     */
    filter: {
      name: "Filter",
      I: PartiesServiceFilterReq,
      O: PartiesList,
      kind: MethodKind.Unary,
    },
    /**
     * Count
     *
     * @generated from rpc nail2poll.PartiesService.Count
     */
    count: {
      name: "Count",
      I: CountRequest,
      O: CountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ------------------------------------------------------
     * Import and Export operations are listed below
     * Import from CSV file
     *
     * @generated from rpc nail2poll.PartiesService.Import
     */
    import: {
      name: "Import",
      I: CSVImport,
      O: ErroredResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Export to CSV file
     *
     * @generated from rpc nail2poll.PartiesService.Export
     */
    export: {
      name: "Export",
      I: PartiesServiceFilterReq,
      O: StandardFile,
      kind: MethodKind.Unary,
    },
  }
} as const;

